export default __webpack_public_path__ + "static/media/VolvoNovum-Bold.f2635f8c.woff2";